import React from "react";

const StatusBadge = ({ isDeleted, onClick }) => {
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: isDeleted ? "#ffe5e5" : "#E3F5E1",
        width: "90px",
        height: "28px",
        justifyContent: "space-around",
        alignItems: "center",
        borderRadius: "6px",
        padding: "4px 8px",
        border: `1px solid ${isDeleted ? "#cc0000" : "rgba(116, 206, 106, 1)"}`,
        cursor: onClick ? "pointer" : "default"
      }}
      onClick={(e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
    >
      <div
        style={{
          width: "7px",
          height: "7px",
          background: isDeleted ? "#cc0000" : "rgba(116, 206, 106, 1)",
          borderRadius: "50%",
        }}
      />
      <span style={{ fontSize: "12px", fontWeight: "600", color: isDeleted ? "#cc0000" : "#313131" }}>
        {isDeleted ? "Inactive" : "Active"}
      </span>
    </div>
  );
};

export default StatusBadge;
